// extracted by mini-css-extract-plugin
module.exports = {"tablepd":"index_tablepd_3-nbh","locked":"index_locked_1QdiX"};